import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "timeline-item" }
const _hoisted_2 = { class: "timeline-icon symbol symbol-circle symbol-40px" }
const _hoisted_3 = { class: "symbol-label bg-light" }
const _hoisted_4 = { class: "svg-icon svg-icon-2 svg-icon-gray-500" }
const _hoisted_5 = { class: "timeline-content mb-10 mt-n1" }
const _hoisted_6 = { class: "pe-3 mb-5" }
const _hoisted_7 = { class: "d-flex align-items-center mt-1 fs-6" }
const _hoisted_8 = {
  class: "symbol symbol-circle symbol-25px",
  "data-bs-toggle": "tooltip",
  "data-bs-boundary": "window",
  "data-bs-placement": "top",
  title: "Marcus Dotson"
}
const _hoisted_9 = ["alt"]
const _hoisted_10 = { class: "overflow-auto pb-5" }
const _hoisted_11 = { class: "d-flex align-items-center border border-dashed border-gray-300 rounded min-w-700px p-7" }
const _hoisted_12 = { class: "overlay me-10" }
const _hoisted_13 = { class: "overlay-wrapper" }
const _hoisted_14 = ["alt"]
const _hoisted_15 = { class: "overlay me-10" }
const _hoisted_16 = { class: "overlay-wrapper" }
const _hoisted_17 = ["alt"]
const _hoisted_18 = { class: "overlay" }
const _hoisted_19 = { class: "overlay-wrapper" }
const _hoisted_20 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "timeline-line w-40px" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_inline_svg, {
            src: "/media/icons/duotune/art/art005.svg",
            "aria-hidden": "true"
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "fs-5 fw-bold mb-2" }, " 3 new application design concepts added: ", -1)),
        _createElementVNode("div", _hoisted_7, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-muted me-2 fs-7" }, "Created at 4:23 PM by", -1)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("img", {
              src: "/media/avatars/150-3.jpg",
              alt: _ctx.translate('FACE_OF_A_PERSON')
            }, null, 8, _hoisted_9)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("img", {
                alt: _ctx.translate('III_PLUS_LOGO'),
                class: "rounded w-200px",
                src: "/media/valored/iii_logo.png"
              }, null, 8, _hoisted_14)
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "overlay-layer bg-dark bg-opacity-10 rounded" }, [
              _createElementVNode("a", {
                href: "#",
                class: "btn btn-sm btn-primary btn-shadow"
              }, "Explore")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("img", {
                alt: _ctx.translate('FACE_OF_A_PERSON'),
                class: "rounded w-200px",
                src: "/media/valored/iii_logo.png"
              }, null, 8, _hoisted_17)
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "overlay-layer bg-dark bg-opacity-10 rounded" }, [
              _createElementVNode("a", {
                href: "#",
                class: "btn btn-sm btn-primary btn-shadow"
              }, "Explore")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("img", {
                alt: _ctx.translate('FACE_OF_A_PERSON'),
                class: "rounded w-200px",
                src: "/media/valored/iii_logo.png"
              }, null, 8, _hoisted_20)
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "overlay-layer bg-dark bg-opacity-10 rounded" }, [
              _createElementVNode("a", {
                href: "#",
                class: "btn btn-sm btn-primary btn-shadow"
              }, "Explore")
            ], -1))
          ])
        ])
      ])
    ])
  ]))
}